import React, { useContext, useState } from 'react';
import { number } from 'prop-types';
import { Button } from 'react-bootstrap';

import { ToastContext } from './context/ToastContext';

import '../styles/FollowQuestion.css';

function FollowQuestion({ questionId }) {
    const [loading, setLoading] = useState(false);
    const { sendMessage } = useContext(ToastContext);

    const followQuestion = async () => {
        try {
            setLoading(true);
            const url = new URL(`/api/questions/${questionId}/follow`, process.env.APP_URL);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            const { success, error } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (success) {
                sendMessage('Question followed successfully. You will receive an email for every answer.', 'success');
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            setLoading(false);
        }
    };

    return (
        <p
            className={'follow-question'}
        >
            Do you have the same question?
            <Button
                variant={'link'}
                onClick={followQuestion}
                disabled={loading}
            >
                Follow this Question
            </Button>
        </p>
    );
}

FollowQuestion.propTypes = {
    questionId: number,
};

export default FollowQuestion;